(function () {
  'use strict';

  angular.module('unit.info', ['ui.router', 'ngResource']);
})();
